import {
  BarChartOutlined,
  DashboardOutlined,
  SettingOutlined,
  TeamOutlined,
  UserSwitchOutlined,
  ShopOutlined,
  TagsOutlined
} from '@ant-design/icons';

const gym = {
  id: 'group-gym',
  title: 'Gym Workspace',
  type: 'group',
  children: [
    { id: 'dashboard', title: 'Dashboard', type: 'item', url: '/dashboard', icon: DashboardOutlined },
    { id: 'member_request', title: 'Membership Request', type: 'item', url: '/membership-request', icon: TeamOutlined },
    { id: 'members', title: 'Members', type: 'item', url: '/members', icon: TeamOutlined },
    { id: 'trainers', title: 'Trainers', type: 'item', url: '/trainers', icon: UserSwitchOutlined },
    { id: 'specializations', title: 'Specializations', type: 'item', url: '/specializations', icon: TagsOutlined },
    // { id: 'features', title: 'Feature Toggles', type: 'item', url: '/features', icon: SettingOutlined },
    // { id: 'profile', title: 'Gym Profile', type: 'item', url: '/profile', icon: ShopOutlined },
    { id: 'analysis', title: 'Progress & Analysis', type: 'item', url: '/analysis', icon: BarChartOutlined }
  ]
};

export default gym;
